export default __webpack_public_path__ + "static/media/keyboardArrowDown.267c8b03.svg";